import axios from "axios";
import { BaseService, sipondApiToken, sipondBaseURL } from "./base.service";
import {
  InfoResponse,
  StudentAbsencesResponse,
  StudentAchievementResponse,
  StudentBioResponse,
  StudentGenderResponse,
  StudentHealthResponse,
  StudentMarhalahResponse,
  StudentTahfidzResponse,
  StudentViolationsResponse,
} from "./dtos/school.dto";

interface SchoolServiceInterface {
  queries: {
    GET_SCHOOL_INFO: string;
    GET_SCHOOL_STUDENT_BIO: string;
    GET_SCHOOL_STUDENT_GENDER: string;
    GET_SCHOOL_STUDENT_HEALTH: string;
    GET_SCHOOL_STUDENT_VIOLATIONS: string;
    GET_SCHOOL_STUDENT_ACHIEVEMENT: string;
    GET_SCHOOL_STUDENT_ABSENCES: string;
    GET_SCHOOL_STUDENT_TAHFIDZ: string;
    GET_SCHOOL_STUDENT_MARHALAH: string;
  };
  info(): Promise<InfoResponse>;
  studentBio(): Promise<StudentBioResponse>;
  studentGender(payload: { nis: string }): Promise<StudentGenderResponse>;
  studentMarhalah(payload: { nis: string }): Promise<StudentMarhalahResponse>;
  studentHealth(limit: string): Promise<StudentHealthResponse>;
  studentTahfidz(payload: { limit: string }): Promise<StudentTahfidzResponse>;
  studentViolations(payload: {
    limit: string;
  }): Promise<StudentViolationsResponse>;
  studentAchievement(payload: {
    nis: string;
    limit: string;
  }): Promise<StudentAchievementResponse>;
  studentAbsences(payload: { limit: string }): Promise<StudentAbsencesResponse>;
}
export const SchoolService: SchoolServiceInterface = {
  queries: {
    GET_SCHOOL_INFO: "GET_SCHOOL_INFO",
    GET_SCHOOL_STUDENT_BIO: "GET_SCHOOL_STUDENT_BIO",
    GET_SCHOOL_STUDENT_HEALTH: "GET_SCHOOL_STUDENT_HEALTH",
    GET_SCHOOL_STUDENT_VIOLATIONS: "GET_SCHOOL_STUDENT_VIOLATIONS",
    GET_SCHOOL_STUDENT_ACHIEVEMENT: "GET_SCHOOL_STUDENT_ACHIEVEMENT",
    GET_SCHOOL_STUDENT_ABSENCES: "GET_SCHOOL_STUDENT_ABSENCES",
    GET_SCHOOL_STUDENT_TAHFIDZ: "GET_SCHOOL_STUDENT_TAHFIDZ",
    GET_SCHOOL_STUDENT_GENDER: "GET_SCHOOL_STUDENT_GENDER",
    GET_SCHOOL_STUDENT_MARHALAH: "GET_SCHOOL_STUDENT_MARHALAH",
  },
  info: async () => {
    try {
      const request = await axios.get<StudentGenderResponse>(
        `${sipondBaseURL}/api/sekolah/info`,
        {
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  studentBio: async () => {
    try {
      const request = await BaseService.request().get<StudentBioResponse>(
        "/school/student-bio"
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  studentGender: async (payload: { prefix: string; nis: string }) => {
    try {
      const request = await axios.get<StudentGenderResponse>(
        `${sipondBaseURL}/api/biodata/gender`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentMarhalah: async (payload: { nis: string }) => {
    try {
      const request = await axios.get<StudentMarhalahResponse>(
        `${sipondBaseURL}/api/siswa/marhalah`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentHealth: async (limit: string) => {
    try {
      const request = await BaseService.request().get<StudentHealthResponse>(
        "/school/student-health",
        { params: { limit } }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  studentTahfidz: async (payload: { limit: string }) => {
    try {
      const request = await axios.get<StudentTahfidzResponse>(
        `${sipondBaseURL}/api/orangtua/tahfidz-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  studentViolations: async (payload: { limit: string }) => {
    try {
      const request = await axios.get<StudentViolationsResponse>(
        `${sipondBaseURL}/api/orangtua/violation-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  studentAchievement: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<StudentAchievementResponse>(
        `${sipondBaseURL}/api/orangtua/achievement-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  studentAbsences: async (payload: { limit: string }) => {
    try {
      const request = await axios.get<StudentAbsencesResponse>(
        `${sipondBaseURL}/api/orangtua/absence-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
